import { PlusIcon } from 'lucide-react';
import { PostChip } from './PostChip';
import { iso, longDate, shortDate, today, weekdayShort } from '../../core/format/dates';
import type { MarketingDesign } from '../../core/types/marketing';
import type { SocialPost } from '../../core/types/social';
type Props = {
  days: Date[];
  posts: SocialPost[];
  designById: (id?: string) => MarketingDesign | undefined;
  onPlan: (date: string) => void;
};

/**
 * Zeven kolommen op de computer, een lijst van dagen op de telefoon.
 * Een lege dag heeft één knop: iets plannen.
 */
export function WeekGrid({
  days,
  posts,
  designById,
  onPlan
}: Props) {
  const now = today();
  return <div className="grid gap-2 lg:grid-cols-7 lg:gap-3" data-id="element-4517" data-mp="2t9pkdiul4ubt">
      {days.map(d => {
      const day = iso(d);
      const items = posts.filter(p => p.date === day).sort((a, b) => a.time.localeCompare(b.time));
      const isToday = day === now;
      const past = day < now;
      return <section key={day} aria-label={`${longDate(d)}${isToday ? ', vandaag' : ''}`} className={`flex flex-col rounded-lg p-2.5 lg:min-h-[340px] ${isToday ? 'bg-white ring-1 ring-clay/50' : past ? 'bg-white/40 ring-1 ring-line' : 'bg-white/70 ring-1 ring-line'}`} data-id="element-4518" data-mp="di1pru31ndw6">
            <header className="flex items-center justify-between gap-2 px-0.5 pb-2 lg:items-baseline" data-id="element-4519" data-mp="24plri2pn2qvc">
              <span className="flex items-baseline gap-2" data-id="element-4520" data-mp="1zqsfyftwx9xt">
                <span className={`text-[13px] capitalize ${isToday ? 'text-clay' : 'text-muted'}`} data-id="element-4521" data-mp="1zsd8y10kwktk">
                  {isToday ? 'Vandaag' : weekdayShort(d)}
                </span>
                <span className={`font-display text-[20px] leading-none ${isToday ? 'text-clay' : past ? 'text-muted' : 'text-ink'}`} data-id="element-4522" data-mp="1qygnypj5hefq">
                  {d.getDate()}
                </span>
                <span className="text-[12px] text-muted lg:hidden" data-id="element-4523" data-mp="1gyg514p710c2">{shortDate(d).replace(/^\d+\s/, '')}</span>
              </span>
              <button type="button" onClick={() => onPlan(day)} aria-label={`Post plannen op ${longDate(d)}`} className="inline-flex h-9 w-9 items-center justify-center rounded-md text-muted transition-colors duration-150 ease-soft hover:bg-sand hover:text-ink lg:hidden" data-id="element-4524" data-mp="1c2ra5eo4c7m3">
                <PlusIcon className="h-4 w-4" strokeWidth={1.75} data-id="element-4525" data-mp="xf0pugn1ttks" />
              </button>
            </header>

            {items.length > 0 && <ul className="space-y-2" data-id="element-4526" data-mp="1l5mvy2dht3s5">
                {items.map(p => <li key={p.id} data-id="element-4527" data-mp="1q1v8d80b2ivm">
                    <PostChip post={p} design={designById(p.designId)} data-id="element-4528" data-mp="1cb88hcit6mxy" />
                  </li>)}
              </ul>}

            <button type="button" onClick={() => onPlan(day)} aria-label={`Post plannen op ${longDate(d)}`} className={`mt-2 hidden items-center justify-center gap-1 rounded-md border border-dashed border-line py-2 text-[12px] text-muted transition-colors duration-150 ease-soft hover:border-ink/30 hover:bg-white hover:text-ink lg:flex ${items.length ? '' : 'lg:mt-0 lg:flex-1'}`} data-id="element-4529" data-mp="1gbiprlc1wzs4">
              <PlusIcon className="h-3.5 w-3.5" strokeWidth={1.75} data-id="element-4530" data-mp="748hqsrjx2zi" />
              <span aria-hidden="true" data-id="element-4531" data-mp="24vw2bcf21yi">Plan</span>
            </button>
          </section>;
    })}
    </div>;
}